export default __webpack_public_path__ + "static/media/profile-pic-placeholder.a92fc4b3.jpg";